import styled, { css } from 'styled-components';

export const GaugeContainer = styled.div`
  width: 296px;
  height: 206px;
  overflow: visible;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const GaugeSvg = styled.svg`
  width: 100%;
  height: 100%;
  margin-top: -20px;
  overflow: visible;
`;

type FakeInputProps = {
  isError?: boolean;
};

export const InputWrapper = styled.div<FakeInputProps>`
  width: 60%;
  padding: 8px;
  font-size: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  width: 100%;
  height: 52px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  gap: 32px;

  ${({ isError }) =>
    isError &&
    css`
      border: 1px solid #e74141;
    `}
`;

export const InputLabel = styled.span`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 14px;
  color: #d9d9d9;
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 17px;
  color: #3d3d3d;
`;

export const FakeInput = styled.div`
  cursor: pointer;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;
`;

export const ComplementInput = styled.span`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 17px;
  color: #3d3d3d;
`;

export const DraggableCircle = styled.circle`
  cursor: pointer;
`;
